import React from "react";
import { connect, useSelector } from "react-redux";
import PropTypes from "prop-types";
import "../OrderOptions.scss";
import { Container, Row, Col, Form } from "react-bootstrap";
import messages from "../../../assets/i18n";
import { ALGODAO_BCI, DEMAIS_ATRIBUTOS_SUSTENTAVEIS } from '../../../utils/constants';
import formatCnpj from '../../../helpers/formatCnpj';

function OrderOptionsOrderTab(props) {
    const { pedido } = props;
    const lang = useSelector(state => state.language.name)
    const pageMessages = messages[lang].orderOptions

    return (
        <Container>
            <Row>
                <Form.Group as={Col} xs={3} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.id}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.id}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={3} className="mt-1">
                    <Form.Label className="text-2">{
                        pedido.naturezaPedido === 'Amostra' ? 
                            pageMessages.pedidoOrigem
                        :
                            pageMessages.pedidoAmostra
                    }</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.amostraPedido || pedido.origemPedido}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={3} className="mt-1">
                    <Form.Label className="text-2">{
                        pedido.naturezaPedido === 'Amostra' ? 
                            pedido.origemStatus === 'C' ? pageMessages.dtCancelamentoOrigem : pageMessages.dtEntregaOrigem
                            :
                            pedido.amostraStatus === 'C' ? pageMessages.dtCancelamentoAmostra : pageMessages.dtEntregaAmostra
                       
                    }
                    </Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="date"
                        defaultValue={
                            pedido.naturezaPedido === 'Amostra' ? 
                                pedido.origemDtCancelamento
                            :
                                pedido.amostraDtCancelamento
                        }
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={3} className="mt-1">
                    <Form.Label className="text-2">{
                        pedido.naturezaPedido === 'Amostra' ? 
                            pageMessages.statusOrigem
                        :
                            pageMessages.statusAmostra
                    }</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={
                            pedido.naturezaPedido === 'Amostra' ? 
                                messages[lang].statusOrder[pedido.origemStatus]
                            :
                                messages[lang].statusOrder[pedido.amostraStatus]
                        }
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} xs={3} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.naturezaPedido}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.naturezaPedido}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={3} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.status}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.prePo === 'Y' ? messages[lang].preRegistrationStatus : messages[lang].statusOrder[pedido.status]}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.pais}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.pais}
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} xs={3} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.pgCondId}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.pgCondId}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={3} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.pgCond}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.pgCond}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.pgDiasPrazo}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.pgDiasPrazo}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.tipoPedido}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.tipoPedido}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.tipoPedidoDescricao}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.tipoPedidoDescricao}
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.departamentoId}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.departamentoId}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={3} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.departamento}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.departamento}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.ffdd}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="date"
                        defaultValue={pedido.ffdd}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={3} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.sustentabilidade}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.sustentabilidade === ALGODAO_BCI ? 'Algodão BCI' :
                            pedido.sustentabilidade === DEMAIS_ATRIBUTOS_SUSTENTAVEIS ? 'Demais Atributos Sustentáveis' :
                                'Não'}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.termosFrete}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.termosFrete}
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.qtCompra}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="number"
                        defaultValue={pedido.qtCompra}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.qtPacotes}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="number"
                        defaultValue={pedido.qtPacotes}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.qtPecas}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="number"
                        defaultValue={pedido.qtPecas}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.qtVolumes}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="number"
                        defaultValue={pedido.qtVolumes}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.fastInd}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.fastInd}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.cnpjComprador}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.cnpjComprador ? formatCnpj(pedido.cnpjComprador) : ''}
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.dtEmissao}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="date"
                        defaultValue={pedido.dtEmissao}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pedido.status === 'D' ? pageMessages.dtEntrega : pageMessages.dtCancelamento}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="date"
                        defaultValue={pedido.dtCancelamento}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.dtEntregaInicio}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="date"
                        defaultValue={pedido.dtEntregaInicio}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.dtEntregaFim}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="date"
                        defaultValue={pedido.dtEntregaFim}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.dtRecebimentoPo}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="date"
                        defaultValue={pedido.dtRecebimentoPo}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={2} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.versao}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.versao}
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} xs={4} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.formaPgId}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.formaPgId}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={4} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.formaPg}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.formaPg}
                        readOnly={true}
                    />
                </Form.Group>
                <Form.Group as={Col} xs={4} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.importacaoContaOrdem}</Form.Label>

                    <div key={`inline-radio`} className="text-2">
                        <div key={pedido.id}>
                            <Form.Check
                                inline
                                label={messages[lang].yes}
                                name="utilCodeRadio"
                                type="radio"
                                defaultChecked={pedido.utilCode && pedido.utilCode === '1109' ? true : false}
                                id={`inline-radio-1`}
                                disabled={true}
                            />
                            <Form.Check
                                inline
                                label={messages[lang].no}
                                name="utilCodeRadio"
                                type="radio"
                                defaultChecked={!pedido.utilCode || pedido.utilCode !== '1109' ? true : false}
                                id={`inline-radio-2`}
                                disabled={true}
                            />
                        </div>
                    </div>
                </Form.Group>
            </Row>
            <Row>
                <Form.Group as={Col} className="mt-1">
                    <Form.Label className="text-2">{pageMessages.observacao}</Form.Label>
                    <Form.Control
                        className="text-2 border-radius-full"
                        type="text"
                        defaultValue={pedido.observacao}
                        readOnly={true}
                    />
                </Form.Group>
            </Row>
        </Container>
    );
}

OrderOptionsOrderTab.propTypes = {
    pedido: PropTypes.object
};

const mapStateToProps = state => ({
    lang: state.language
});

export default connect(mapStateToProps)(OrderOptionsOrderTab);

